<template>
  <div>
    <div class="myCourse_content">
      <div class="leftTemplate"   :class="{'filterbgs': grayTheme }">
        <div class="leftScore">
          <div class="ar_title">
            <span>焦点直播</span>
            <span style="cursor: pointer;" @click="moreNew">更多赛事 <i style="color: #999;" class="el-icon-arrow-right"></i> </span>
          </div>
          <div class="scoreStatus">
            即时比赛
          </div>
        </div>
        <div class="score_game" :loading='scoresList.length>0?false:true' >
              <div class="game_item" @click="navChange(item)" :loading='item.league?false:true' v-if="index <5  " v-for="(item,index) in scoresList" :key="index">
                  <div class="softgameimg" style="margin-right: 8px;">
                    <img src="https://oss.ansongqiubo.com/static/scope/defaultqiu.png" alt="" srcset="">
                  </div>
                  <div class="geme_time" v-if="item.matchInfo">
                      <span>
                        {{ffTime(item.matchInfo.matchStartTime)}}
                      </span>
                      <span>
                        {{ffDate(item.matchInfo.matchStartTime)}}
                      </span>
                  </div>
                  <div class="geme_title" :style="{'color':item.league && item.league.color}">
                      {{item.league.nameCnShort}}
                  </div>
                  <div class="game_status">
                       <img src="https://oss.ansongqiubo.com/static/scope/time.png" alt="" srcset="" v-if="item.matchInfo.state !=0"><span :class="item.matchInfo.state == 0?'greys':''">{{item.matchInfo.ffscope}}</span>
                       <img v-if="item.matchInfo.state > 0 && item.matchInfo.state !=2" style="width:5px;height:14px" src="https://oss.ansongqiubo.com/static/scope/in.gif" alt="" srcset="">
                  </div>
                  <div class="ganm_uname" style="justify-content: flex-end;">
                    <span v-if="item.matchData.homeYellowNum > 0" class="awayYellowNum">
                      {{item.matchData.homeYellowNum}}
                    </span>
                    <span v-if="item.matchData.homeRedNum >0 " class="awayRedNum">
                     {{item.matchData.homeRedNum}}
                    </span>
                     <div class="minwidth myfont1" style="text-align: right;"> {{item.homeTeam.nameCn}}</div>
                     <img style="margin-left: 6px;" :src="item.homeTeam.customLogo?item.homeTeam.customLogo:'https://oss.ansongqiubo.com/static/scope/defaultqiu.png'" alt="" srcset="">
                  </div>
                  <div class="game_bifen" v-if="item.matchInfo.state !==0">
                    {{item.matchData.homeScore}} - {{item.matchData.awayScore}}
                  </div>
                  <!-- 未开始状态 -->
                  <div class="game_bifen" style="color: #333;" v-else>
                    -
                  </div>
                  <div class="ganm_uname" style="justify-content: flex-start;">
                    <img style="margin-right: 6px;" :src="item.awayTeam.customLogo?item.awayTeam.customLogo:'https://oss.ansongqiubo.com/static/scope/defaultqiu.png'" alt="" srcset="">
                    <div class="minwidth myfont1" style="text-align: left;"> {{item.awayTeam.nameCn}}</div>
                    <span v-if="item.matchData.awayRedNum >0 " class="awayRedNum">
                     {{item.matchData.awayRedNum}}
                    </span>
                    <span v-if="item.matchData.awayYellowNum > 0" class="awayYellowNum">
                      {{item.matchData.awayYellowNum}}
                    </span>
                  </div>
                  <div class="play_game" style="min-width: 64px;">

                    <img v-if="item.anchor" @click.stop="openVideo(1,item)"  src="https://oss.ansongqiubo.com/static/scope/live.png" alt="" srcset="">
                    <img v-if="!item.ancho && item.matchLiveVO.haveAnimation == 1" @click.stop="openVideo(2,item)" src="https://oss.ansongqiubo.com/static/scope/animal.png" alt="" srcset="">
                    <i  style="color: #999;" class="el-icon-arrow-right"></i>
                  </div>
              </div>
        </div>
      </div>
      <div class="rightTemplate"   :class="{'filterbgs': grayTheme }">
        <div class="rightScore">
          <div class="ar_title">
            <span>积分榜</span>
            <span></span>
          </div>
          <div class="rowscorelist">
            <div @click="changesoft(item,index)" v-if="index < 5" v-for="(item,index) in hottabList" class="softitem " :key="index">
              <span>{{item.nameCnShort}}</span>
            </div>
            <div class="activeqiu" :style="'left:'+ (100 / 5) * (checkIndex) +'%'" >{{selectName.nameCnShort}}</div>
          </div>
        </div>

        <div class="conetentdata">
            <div class="tableHeader">
              <span style="text-align: center;">排名</span>
              <span style="text-align: left;">
                球队
              </span>
              <span style="text-align: right;">
                胜/平/负
              </span>
              <span style="text-align: center;">积分</span>
            </div>
            <div class="scrollscope">
              <div class="bangitem" v-for="(items,index) in eagueRankList" :key="index">
                <div style="text-align: center;" :class="index < 3?'activeColor':''">{{items.allLeagueRank.rank}}</div>
                <div style="text-align: left;display: flex;align-items: center;">
                  <img :src="items.teamData.customLogo?items.teamData.customLogo:'https://oss.ansongqiubo.com/static/scope/defaultqiu.png'" alt="" srcset="">
                  <span style="min-width: 110px;" class="myfont1">{{items.teamData.nameCn}}</span>
                </div>
                <div style="text-align: center">
                  {{items.allLeagueRank.winCount}}/{{items.allLeagueRank.drawCount}}/{{items.allLeagueRank.loseCount}}
                </div>
                <div style="text-align: center;color: #ED1010;">{{items.allLeagueRank.integral}}</div>
              </div>
            </div>
        </div>
      </div>
      <dialogLive :userLive='userLive' ref="dialogLive"></dialogLive>
    </div>
  </div>

</template>

<script>
  import {timelyList ,hotList,leagueRank,matchListBeRelevanceAnchorList,matchHotList,hotMatchBeRelevanceAnchorList} from '@/api/scope.js'

  let GLOABL_TIME = null;
  import moment  from 'moment'
  import momentDurationFormatSetup from 'moment-duration-format';
  momentDurationFormatSetup(moment);

  import dialogLive from '@/pages/components/lz_dialogLives.vue';
  import GlobalInfo from '@/lib/scoreSocket.js'
  let Times = null
  export default {
    components:{
      dialogLive
    },
    data() {
      return {
        key:'kay',
        userLive:[],
        checkIndex:0,
        hottabList:[],
        scoresList:[],
        mouseIndex:0,
        eagueRankList:[],
        selectName:{
          nameCnShort:''
        },
        articleId:0,
      }
    },
    beforeDestroy() {
      clearInterval(GLOABL_TIME)
    },
    created() {
      clearInterval(GLOABL_TIME)
      this.initData();
      this.initGlobal()
    },
    computed:{
      grayTheme(){
        let data = JSON.parse(localStorage.getItem('userSettingInfo') || {}) ; // grayTheme
        return data && data.grayTheme
      }
    },
    methods:{
      pageRouter(query){
        this.$store.commit('pageRouter',{
          type:1,
          query,
        })
      },
      navChange(item){
        this.pageRouter({
          path: "/pageAnalyse",
          query: {rid:2, tabId:3,matchId:item.matchInfo.matchId},
        })
      },
      openVideo(e,val){
        console.log(val,e);
        if(e == 1){
          this.userLive = val.liveData.relevanceMatchAnchorVOList;
          this.$refs.dialogLive.open()
          // // 直播间
          // const neww = this.$router.resolve({
          //   path: "/pageAnalyse",
          //   query: {rid:3, tabId:val,matchId:this.matchId},
          // });
          // window.open(neww.href, "_blank");
        }
        if(e ==2){
          // 动画
          this.pageRouter({
            path: "/pageAnalyse",
            query: {rid:3, tabId:3,matchId:val.matchInfo.matchId},
          })
        }
      },
      async initGlobal(){
        GlobalInfo.sucess =(e)=>{
          let Info = JSON.parse(e.data);
          // console.log('首页socket',Info);
          switch (Info.messageType){
            case 10001:
              this.objectchange(Info.message)
              console.log('比赛比分相关数据推送',Info.message);
              break;
            case 10002:
              // console.log('比赛相关事件',Info.message);
              break;
            case 10003:
              // console.log('比赛事件(删除错误的事件)',Info.message);
              break;
            case 10004:
              // console.log('比赛角球事件',Info.message);
              break;
            case 10005:
              // console.log(' 球队技术统计',Info.message);
              break;
            default:
              break;
          }
        }
      },
      // 模拟数据
      mockScoket(){
        let obj = {
           "matchDataVO": { // 比分相关数据
               "awayCornerNum": 0, // 客队角球数
               "awayHalfCornerNum": 0, // 客队（半场）角球数
               "awayHalfScore": 0, // 客队（半场）比分
               "awayRedNum": 0, // 客队红牌数
               "awayScore": 0, // 客队比分
               "homeCornerNum": 1, // 主队角球数
               "homeHalfCornerNum": 0, // 主队(半场)角球数
               "homeHalfScore": 0, // 主队(半场)比分
               "homeYellowNum":0, // 主队黄牌数
               "awayYellowNum":0, // 客队黄牌数
               "homeRedNum": 0, // 主队红牌数
               "homeScore": 0 // 主队比分
             },
             "matchExtraVO": { // 比赛加时数据
                "extraScore": "", // 加时: 加时阶段比分
                "extraType": 0,// 加时: 加时阶段类型，1:120分钟，2：加时，3：加时中
                "firstKick": 0,// 加时: 先开球方，1：主队先开球，2：客队先开球
                "normalScore": "",// 加时: 常规时间的比分
                "normalTime": 0,// 加时: 常规时间
                "penaltyKickScore": "",// 加时: 点球大战比分
                "twoLegsScore": "",// 加时: 两回合总比分, 该字段仅在比赛有加时、点球的情况才更新
                "win": 0 // 加时: 获胜方，1：主队获胜，2：客队获胜
             },
             "matchInfoVO": { // 比赛基本信息
                "awayId": 49301, // 客队ID
                "firstHalfStartTime": 1658147334,// 上半场开始时间，单位：秒(有时候没有)
                "homeId": 35691,// 主队ID
                "matchId": 54119, // 比赛ID
                "state":0, // 比赛ID
                "matchStartTime": 1658147400, // 比赛时间，单位：秒
                "secondHalfStartTime": 0 // 下半场开始时间，单位：秒
             }
        }
      },
      // 比分合并
      objectchange(data){
         console.log('咋不执行了呢',data,this.scoresList);
         let {matchInfoVO,matchExtraVO,matchDataVO}  = data;
         let changeArrIndex = 0
         // 找到需要变更的赛事
         let newArr  = this.scoresList.filter((item,index)=>{
            if(item.matchId == matchInfoVO.matchId){
              changeArrIndex = index;
              return true
            }else{
              return false
            }
          });

          console.log('获取数据',newArr,data,this.scoresList);
         if(newArr.length > 0){




          let {
             awayCornerNum, // 客队角球数
             awayHalfCornerNum, // 客队（半场）角球数
             awayHalfScore, // 客队（半场）比分
             awayRedNum, // 客队红牌数
             awayScore, // 客队比分
             homeCornerNum, // 主队角球数
             homeHalfCornerNum, // 主队(半场)角球数
             homeHalfScore, // 主队(半场)比分
             homeYellowNum, // 主队黄牌数
             awayYellowNum, // 客队黄牌数
             homeRedNum, // 主队红牌数
             homeScore // 主队比分
          } = matchDataVO;
          let {
              extraScore, // 加时: 加时阶段比分
              extraType,// 加时: 加时阶段类型，1:120分钟，2：加时，3：加时中
              firstKick,// 加时: 先开球方，1：主队先开球，2：客队先开球
              normalScore,// 加时: 常规时间的比分
              normalTime,// 加时: 常规时间
              penaltyKickScore,// 加时: 点球大战比分
              twoLegsScore,// 加时: 两回合总比分, 该字段仅在比赛有加时、点球的情况才更新
              win, // 加时: 获胜方，1：主队获胜，2：客队获胜
          } = matchExtraVO;
          let {
              awayId, // 客队ID
              firstHalfStartTime,// 上半场开始时间，单位：秒(有时候没有)
              homeId,// 主队ID
              matchId, // 比赛ID
              state, // 比赛状态
              matchStartTime, // 比赛时间，单位：秒
              secondHalfStartTime // 下半场开始时间，单位：秒
          } = matchInfoVO;
            let obj = {
              matchData:{  // 比赛相关数据
                awayCornerNum,  // 客队角球数(全场)
                awayHalfScore,  // 客队比分(半场)
                awayRedNum,     // 客队红牌数(全场)
                awayScore,      // 客队比分(全场)
                homeCornerNum,  // 主队角球数
                matchId,
                homeYellowNum,  // 主队黄牌数
                awayYellowNum,  // 客队黄牌数
                homeHalfScore,  // 主队(半场)比分
                homeRedNum,     // 主队红牌数
                homeScore,      // 主队比分
              },
              matchExtra:{
                extraScore,
                extraType,
                firstKick,
                normalScore,
                normalTime,
                penaltyKickScore,
                twoLegsScore,
                win,
              },
              matchInfo:{
                state,
                matchId,
                firstHalfStartTime,
                matchStartTime,
                secondHalfStartTime,
              },
            }
            newArr[0].matchData = obj.matchData;
            newArr[0].matchExtra = obj.matchExtra;
            newArr[0].matchInfo = obj.matchInfo;
            this.scoresList[changeArrIndex] = newArr[0];
            console.log('我的数据',newArr,changeArrIndex,obj,this.scoresList);
            clearInterval(GLOABL_TIME)
            this.$set(this.scoresList, changeArrIndex, newArr[0]);
            let arr = []
             this.scoresList.map((item,index)=>{
              if(item.matchInfo.state >= 0){
                arr.push(item)
              }
            })
            console.log('比分变化。。。。。。。。。。。。。。。。',arr,matchId,changeArrIndex,state,'。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。。');
            if(arr.length < 5){
              this.getmatchHotList();
               this.scoresList =[]
              console.log('重新拉接口');
            }else{
              this.fifScopeData(arr);
              console.log('比分修改');
            }
            this.timeAdd()
            this.$forceUpdate();
        }
      },
      // 计时
      timeAdd(){
          let  arrs = this.scoresList;
          clearInterval(GLOABL_TIME)
           GLOABL_TIME = setInterval(()=>{
            arrs.forEach(item=>{
                if(item && item.matchInfo.state >= 0){
                    item.matchInfo.ffscope = this.ffscope(item.matchInfo.state,item.matchInfo)
                }
            })
            this.fifScopeData(arrs)
          },1000)
      },
      ffTime(val){
        return moment(val * 1000).format('HH:mm')
      },
      ffDate(val){
        return moment(val * 1000).format('MM-DD')
      },
      fifScopeData(list){
        let arr = []
        this.scoresList = [];
        clearInterval(GLOABL_TIME)
        list.map((item,index)=>{
          let arrs =  this.matchaboutList.filter(val=>val.matchId == item.matchId)
          if(item.matchInfo.state >= 0){
            item.matchInfo.ffscope = this.ffscope(item.matchInfo.state,item.matchInfo);
            if(arrs.length > 0){
              item.anchor = true;
              item.liveData = arrs[0]
            }
            arr.push(item)
          }
          return item
        })
        this.scoresList = arr;
        this.$forceUpdate()
        this.timeAdd()
      },
      // 时间状态
      ffscope(val, obj) {
        let keys = ''
        switch (val) {
          case -14:
            keys = '推迟'
            break;
          case -13:
            keys = '中断'
            break;
          case -12:
            keys = '腰斩'
            break;
          case -11:
            keys = '待定'
            break;
          case -10:
            keys = '取消'
            break;
          case -1:
            keys = '完'
            break;
          case 0:
            keys = '未'
            break;
          case 1:
            keys = '上半场'
            let begin = obj.firstHalfStartTime>0?obj.firstHalfStartTime:obj.matchStartTime;
            // 当前时间 - 比赛开始时间  = 正在进行的时间
            let date = moment.duration(begin, 'seconds').valueOf();
            let times = moment().diff(date, 'm')
            keys = times
            // console.log('上半场数据')
            if(keys > 45){
              keys  = '45+'
            }
            break;
          case 2:
            keys = '中场'
            break;
          case 3:
            // console.log('下半场数据');
            if (obj.secondHalfStartTime > 0) {
              let dates = moment.unix(obj.secondHalfStartTime).valueOf(); // 下半场时间
              let valueTime = moment(new Date()).add(45, 'm').valueOf(); // 当前时间加上 45 分钟
              // 时间差
              let vdata = moment(valueTime).diff(dates, 'm');
              keys = vdata + 1;

              if(keys > 90){
                keys  = '90+'
              }
              // console.log(vdata)
            } else {
              let begin = obj.firstHalfStartTime>0?obj.firstHalfStartTime:obj.matchStartTime;
              let dates = moment.unix(begin).valueOf(); // 上半场时间
             let valueTime = moment().subtract(15, 'm').valueOf(); // 当前时间加上 45 分钟
             let vdata = moment(valueTime).diff(dates, 'm');

              keys = vdata;
              if(keys > 90){
                keys  = '90+'
              }
              // console.log(vdata)
            }
            break;
          case 4:
            keys = '加时'
            break;
          case 5:
            keys = '点球'
            break;
          default:
            break;
        }

        return keys
      },
      async getmatchHotList(){
            let result =  await matchHotList({matchType:1,limit:5});
            console.log('热门比赛',result);
            if(result.data.code ==200){
              let list = result.data.data;
              let arr = [];
              list.map(item=>{
                if(item.matchType){
                  item.matchVO.matchType = item.matchType
                  arr.push( item.matchVO)
                }
              })
              // 过滤出即时的比赛
            this.fifScopeData(arr);
            this.$forceUpdate()
          }
      },
      async initData(){

        // // 获取比赛列表被关联的主播信息
        // let aboutList = await matchListBeRelevanceAnchorList({
        //   matchType:1,
        //   queryType:1,
        //   dateTime:'',
        // })
        // if(aboutList.data.code == 200){
        //   console.log('我的数据',aboutList.data.data);
        //   matchaboutList = aboutList.data.data
        // }

        this.scoresList = [];
        let aboutList = await hotMatchBeRelevanceAnchorList({
          matchType:1,  // 足球
          limit:5, // 即时
        })

        if(aboutList.data.code == 200){
          console.log('热门比赛的主播信息',aboutList.data.data);
          this.matchaboutList = aboutList.data.data
        }

      //
      this.getmatchHotList();



      //  热门比赛
       let hotValue = await hotList({matchType:1})
       if(hotValue.data.code == 200){
         this.selectName =  hotValue.data.data[0];
         this.hottabList = hotValue.data.data;
         this.getHotList()
       }
       console.log('计时比赛', this.scoresList );
       console.log('积分', this.selectName );
       // 获取比赛列表被关联的主播信息





      },
      changesoft(item,e){
        this.checkIndex = e;
        this.selectName = item;
        this.getHotList()
        console.log((100 / 5) * (this.checkIndex+1));
      },
      getHotList(){
        leagueRank({
          leagueId:this.selectName.leagueId
        }).then(res=>{
          if(res.data.code == 200){
            this.eagueRankList = res.data.data
            console.log('积分',res);
          }
        })
      },
      moreNew(){

        this.pageRouter({
          path: "/pageScore",
          query: { rid:2},
        })
      },
    }
  }
</script>

<style lang="scss">
  ::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 3px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 8px;
  }

  ::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    //background-color: #8c8c8c;
    background-color: rgba(0, 0, 0, 0.25);
  }

  ::-webkit-scrollbar-track {
    background-color: #f6f6f6;
  }

  ::-webkit-scrollbar-thumb,
  ::-webkit-scrollbar-track {
    border: 0;
  }
  .myfont1 {
  	overflow: hidden; //隐藏文字
  	text-overflow: ellipsis; //显示 ...
  	white-space: nowrap; //不换
  }
  .myfont2 {
  	 display: -webkit-box; /* 将对象作为弹性伸缩盒子模型显示 */
  	 -webkit-box-orient: vertical; /* 设置或检索伸缩盒对象的子元素的排列方式 */
  	 -webkit-line-clamp: 2; /* 2行，只有 webkit内核支持 */
  	 word-break: break-all; /* 纯英文换行 */
  	 overflow: hidden;
  }

.myCourse_content{
  width: 1200px;
  display: flex;
  background: #F7F8FA;
  box-sizing: border-box;
  justify-content: space-between;
    .awayRedNum{
      background-color: red;
      color: #fff;
      padding:0 2px;
      margin: 0 2px;
      border-radius: 4px;
    }
    .awayYellowNum{
      background-color: #FFC000;
      color: #fff;
      text-align: center;
      padding:0 2px;
      border-radius: 4px;
      margin: 0 2px;
    }
    .leftTemplate {
      flex: 2;
    }
  .rightTemplate{
    width: 392px;
    .conetentdata{
      margin-top: 10px;
      width: 392px;
      height: 377px;
      background: #FFFFFF;
      border-radius: 6px;
      padding: 0 10px;
      box-sizing: border-box;
      .scrollscope{
        overflow-y: scroll;
        height: 320px;
      }
      .bangitem{
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        border-top: 1px solid rgba(0,0,0,.1);

        .activeColor{
          font-size: 16px;
          font-family: Bebas-Regular, Bebas;
          font-weight: 400;
          color: #ED1010;
        }
        div{
          flex: 1;

          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;


          span{
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
          }
          img{
            width: 20px;
            height: 20px;
            margin-right: 4px;
          }
        }
      }
      .tableHeader{
        height: 46px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        span{
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          flex: 1;
        }
      }
    }
  }
  .score_game{
    width: 796px;
    padding: 20px 0;
    margin-top: 10px;
    box-sizing: border-box;
    height: 377px;
    background: #FFFFFF;
    border-radius: 6px;
    .play_game{
      width:80px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      span{
        display: inline-block;
        margin-left: 6px;
        width: 30px;
        height: 20px;
      }
      img:first-child{
        margin-left: 0 !important;
      }
      img{
        margin-left: 6px;
        width: 30px;
        height: 20px;
      }
    }
    .game_bifen{
      width: 52px;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ED1010;
      text-align: center;
    }
    .game_item:hover{
        background-color: rgba(114, 30, 220, .1);
        border-radius: 4px;
        cursor: pointer;
    }
    .game_item:last-child{
      border-bottom: none;

    }
    .game_item{
      margin: 0 10px;
      box-sizing: border-box;
      padding: 16px 0;
      box-sizing: border-box;
      display:flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid rgba(0,0,0,.1);
      height: 67px;
      .ganm_uname{
        width: 200px;
        span{
          display: inline-block;
          min-width:14px;
          text-align: center;
        }
        .minwidth{
          margin: 0 6px;
        }
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        display: flex;
        align-items: center;
        img{
          width: 20px;
          height: 20px;
        }
      }
      .geme_time{
        display: flex;
        flex-direction: column;
        align-items: center;
        span:nth-child(1){
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #721EDC;
        }
        span:nth-child(2){
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
        }
      }
      .geme_title{
        font-size: 14px;
        width: 140px;
        min-width:80px ;
        text-align: center;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }
      .game_status{
        width: 52px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #721EDC;
        display: flex;
        align-items: center;
        .greys{
          color: #333333 !important;
        }
        img{
          margin-right: 4px;
          width: 14px;
          height: 14px;
        }
      }
      .softgameimg{
        width: 17px;
        height: 17px;
        // background: #000000;
        border-radius: 50%;
        img{
          border-radius: 50%;
          width: 17px;
          height: 17px;
          // background: #000000;
        }
      }
    }
  }
  .leftScore{
    width: 796px;
    height: 105px;
    background: #FFFFFF;
    padding:0 10px;
    box-sizing:border-box;
    border-radius: 6px;
    .scoreStatus{
      font-size: 16px;
      height: 43px;
      line-height: 43px;
      text-align: left;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
    }
    .ar_title{
      display: flex;
      justify-content:space-between;
      align-items: center;
      border-bottom: 1px solid rgba(0,0,0,.1);
      span:nth-child(1){
        border-bottom: 2px solid rebeccapurple;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        height: 60px;
        line-height: 60px;
        font-weight: 600;
        color: #333333;
      }
      span:nth-child(2){
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
    }
  }
  .rightScore{
    width: 392px;
    height: 105px;
    background: #FFFFFF;
    border-radius: 6px;
    .rowscorelist{
      height: 40px;
      margin: 0 10px;
      // width: 392px;
      // overflow-x: scroll;
      display: flex;
      align-items: center;
      position: relative;
      .activeqiu{
        transition: left .3s;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        background: #721EDC !important;
        color: #fff !important;
        cursor: pointer;
        text-align: center;
        margin-right: 20px;
        width: 58px;
        height: 24px;
        border-radius: 2px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 24px;
      }
      .softitem{
        cursor: pointer;
        text-align: center;
        margin-right: 20px;
        width: 58px;
        height: 24px;
        border-radius: 2px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 24px;
        color: #333333;
      }
    }
    .ar_title{
      margin: 0 10px;
      border-bottom: 1px solid rgba(0,0,0,.1);
      box-sizing: border-box;
      display: flex;
      span:nth-child(1){
        display: inline-flex;
        align-items: center;
        height: 60px;
        line-height: 60px;
        border-bottom: 2px solid rebeccapurple;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/template/homescore.vue